import { isCoordinateLocation } from '../realtime/contracts';
import type { Incident, IncidentListItem, CoordinateLocation, Location } from '../realtime/contracts';

export type IncidentListRow = {
  id: string;
  title: string;
  purpose: IncidentListItem['purpose'];
  createdAtUtc: string;
  currentLocation: CoordinateLocation | null;
  isLocationRedacted: boolean;
  agencyNames: readonly string[];
  label: string | null;
};

type RowSource = Pick<IncidentListItem, 'incidentId' | 'title' | 'purpose' | 'createdAtUtc' | 'label'> & {
  currentLocation: Location | null;
  involvedAgencies: readonly { isCollaborating: boolean; displayName: string }[];
};

export function toRow(item: IncidentListItem): IncidentListRow {
  return buildRow(item, item.currentLocation);
}

export function toRowFromIncident(incident: Incident): IncidentListRow {
  return buildRow(incident, incident.caller.currentLocation);
}

function buildRow(source: Omit<RowSource, 'currentLocation'>, location: Location | null): IncidentListRow {
  const coordinates = location != null && isCoordinateLocation(location) ? location : null;

  return {
    id: source.incidentId,
    title: source.title,
    purpose: source.purpose,
    createdAtUtc: source.createdAtUtc,
    currentLocation: coordinates,
    isLocationRedacted: location != null && coordinates === null,
    agencyNames: source.involvedAgencies
      .filter((agency) => agency.isCollaborating)
      .map((agency) => agency.displayName),
    label: source.label,
  };
}
